import styled from 'styled-components';

const Select = styled.select`
  width: auto;
  font-size: 24px;
  line-height: 1;
  border: 0;
  background-color: transparent;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colorMain};
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';

  position: relative;

  @media only screen and (max-width: 810px) {
    font-size: 16px;
    line-height: 19px;
  }

  &:focus {
    outline: 0;
  }
`;

export default Select;
